<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { Record as RecordObject } from '.';

export interface Props {
  record: RecordObject;
  deletable?: boolean;
  downloadable?: boolean;
}

interface Emits {
  (event: 'download' | 'delete'): void;
}

const emit = defineEmits<Emits>();

withDefaults(defineProps<Props>(), {
  deletable: false,
  downloadable: false,
});

const deleteRecord = () => emit('delete');
</script>

<template>
  <div class="flex border border-blue-500 rounded-2xl px-6 py-7 mb-4 gap-4 justify-between bg-white">
    <FontAwesomeIcon
      :icon="['fas', 'file']"
      size="3x"
      class="text-blue-700"
      :class="{'blur-sm': !downloadable}"
    />
    <div
      class="truncate overflow-hidden flex-1"
      :class="[
        {'blur-sm': !downloadable}
      ]"
    >
      <p class="truncate overflow-hidden lg:max-w-40 2xl:max-w-none">
        {{
          downloadable
            ? (record.name ?? record.filename)
            : 'placeholder naam'
        }}
      </p>
      <p class="text-gray-700 truncate text-sm">
        {{
          downloadable ?
            `${record.asset.extension} - ${record.asset.filesize.human}`
            : 'extension'
        }}
      </p>
    </div>
    <div
      v-if="deletable || downloadable && record.asset.absolute_url"
      class="flex flex-row items-center gap-x-2"
    >
      <UIButton
        v-if="downloadable && record.asset.absolute_url"
        :data-test-id="`document-download-${record.id}`"
        title="Download"
        aria-label="Download"
        theme="secondary"
        is-icon
        color="blue"
        @click="$emit('download')"
      >
        <FontAwesomeIcon :icon="['fas', 'file-arrow-down']" size="1x" />
      </UIButton>
      <UIButton
        v-if="deletable"
        :data-test-id="`document-delete-${record.id}`"
        title="Verwijder"
        aria-label="Verwijder"
        theme="secondary"
        is-icon
        color="blue"
        @click="deleteRecord()"
      >
        <FontAwesomeIcon :icon="['fas', 'trash-can']" size="1x" />
      </UIButton>
    </div>
  </div>
</template>
